export const STORAGE_TOKEN = 'token'
export const STORAGE_LANGUAGE = 'lang'
export const STORAGE_INSTITUTION = 'institution'
export const STORAGE_SELECTED_INSTITUTION = 'selected_institution'
export const STORAGE_USER_INFO = 'userInfo'
